import { useEffect } from 'react';

/**
 * iOS Safari 的 100vh 不扣掉上下工具列、100dvh 在部分版本也會抓錯，
 * 唯一可靠的可視高度是 window.innerHeight，量出來寫進 --vh 給 CSS 用。
 *
 * 本來只掛在 return.tsx，所以 /rent 上的彈窗吃不到，max-height 退回 90vh
 * 後整個 panel 比可視範圍高 —— 上面的標題和下面唯一的關閉鈕同時被切掉，
 * 使用者被教學圖困住（2026-09-21 客訴）。改成全站掛一次。
 */
const useViewportHeight = (): void => {
  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
      );
    };

    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    // iOS 捲動收合/展開網址列時不一定發 window resize，但 visualViewport 會
    window.visualViewport?.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
      window.visualViewport?.removeEventListener('resize', setVh);
    };
  }, []);
};

export default useViewportHeight;
